import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export const SiteProvider = ({ children }) => {
  const [state, setState] = useState({ content: null, menu: [], directory: [] });

  const reload = useCallback(async () => {
    const [c, m, d] = await Promise.all([api.get("/content"), api.get("/menu"), api.get("/directory")]);
    setState({ content: c.data, menu: m.data, directory: d.data });
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return <SiteCtx.Provider value={{ ...state, reload }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
